export default "__VITE_ASSET__D$K_KCLR__"